<template>
  <div class="main-container">
    <div class="change-log-page">
      <div class="change-log-page__left">
        <main-menu></main-menu>
      </div>
      <div class="change-log-page__right">
        <div class="form">
          <div class="form__row">
            <div class="form__input-box">
              <input type="radio" class="form__radio" id="hour" value="hour" v-model="pickedRange">
              <label for="hour" class="form__checkbox-label">Last Hour</label>
            </div>

            <div class="form__input-box">
              <input type="radio" class="form__radio" id="day" value="day" v-model="pickedRange">
              <label for="day" class="form__checkbox-label">Today</label>
            </div>

            <div class="form__input-box">
              <input type="radio" class="form__radio" id="week" value="week" v-model="pickedRange">
              <label for="week" class="form__checkbox-label">Last Week</label>
            </div>

            <div class="form__input-box">
              <input type="radio" class="form__radio" id="month" value="month" v-model="pickedRange">
              <label for="month" class="form__checkbox-label">Last Month</label>
            </div>

            <div class="form__input-box">
              <input type="radio" class="form__radio" id="all" value="all" v-model="pickedRange">
              <label for="all" class="form__checkbox-label">All Time</label>
            </div>
          </div>
          <div class="form__row">
            <div class="form__input-box">
              <button class="ark-btn ark-btn--default"
                      @click="fetchLogs()">
                <Loader v-if="isLogLoadInProgress"></Loader>
                <span v-else>Load Logs</span>
              </button>
            </div>
          </div>
        </div>

        <div v-if="!isLogLoadInProgress" class="form">
          <div class="form__row">
            <div class="log-table-container">
              <v-table class="paleBlueRows"
                      :data="logs"
                      :filters="logTable.filters"
                      :currentPage.sync="logTable.currentPage"
                      :pageSize="10"
                      @totalPagesChanged="logTable.totalPages = $event"                   >
                  <thead slot="head">
                      <th>
                        <p>Entity Type</p>
                        <input type="text"
                              class="input-filter"
                              v-model="logTable.filters.entityType.value"
                              placeholder="Filter by type"/>
                      </th>
                      <th>
                        <p>Entity Name</p>
                        <input type="text"
                              class="input-filter"
                              v-model="logTable.filters.entityName.value"
                              placeholder="Filter by name"/>
                      </th>
                      <th>
                        <p>Operation</p>
                        <input type="text"
                              class="input-filter"
                              v-model="logTable.filters.operation.value"
                              placeholder="Filter by operation"/>
                      </th>
                      <th>
                        <p>Author</p>
                        <input type="text"
                              class="input-filter"
                              v-model="logTable.filters.author.value"
                              placeholder="Filter by author"/>
                      </th>
                      <th>
                        <p>Date (UTC)</p>
                        <input type="text"
                              class="input-filter"
                              v-model="logTable.filters.date.value"
                              placeholder="Filter by date"/>
                      </th>
                      <th>
                        <p>Details</p>
                        <input type="text"
                              class="input-filter"
                              v-model="logTable.filters.details.value"
                              placeholder="Filter by details"/>
                      </th>
                  </thead>
                  <tbody slot="body" slot-scope="{displayData}">
                      <tr v-for="row in displayData" :key="row.id">
                        <td>{{ row.entityType }}</td>
                        <td>{{ row.entityName }}</td>
                        <td>{{ row.operation }}</td>
                        <td>{{ formatAuthor(row.author) }}</td>
                        <td>{{ formatDate(row.operationUtcdate) }}</td>
                        <td>{{ row.details }}</td>
                      </tr>
                  </tbody>
              </v-table>
            </div>
            <smart-pagination
              :currentPage.sync="logTable.currentPage"
              :totalPages="logTable.totalPages"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import config from '../../config'
  import Loader from '../Loader/Loader.vue'
  import MainMenu from '../MainMenu/MainMenu.vue'

  export default {
    components: {MainMenu, Loader},
    name: 'ChangeLog',
    props: [],
    data () {
      return {
        logTable: {
          currentPage: 1,
          totalPages: 0,
          filters: {
            date: { value: '', keys: ['operationUtcdate'] },
            entityType: { value: '', keys: ['entityType'] },
            entityName: { value: '', keys: ['entityName'] },
            operation: { value: '', keys: ['operation'] },
            author: { value: '', keys: ['author'] },
            details: { value: '', keys: ['details'] }
          }
        },
        logs: [],
        pickedRange: 'day',
        isLogLoadInProgress: false
      }
    },
    created: function () {
      this.fetchLogs()
    },
    methods: {
      fetchLogs: function () {
        this.isLogLoadInProgress = true
        this.logs = []
        this.$http.get(`${config.apiUrl}/change-log/list?rangeName=${this.pickedRange}`)
          .then(response => {
            this.logs = response.body
            this.isLogLoadInProgress = false
          }, error => {
            this.isLogLoadInProgress = false
            console.log(error)
          })
      },
      formatDate: function (dateString) {
        if (dateString) {
          return dateString.replace(/T/, ' ').replace(/\..+/, '')
        }
        return dateString
      },
      formatAuthor: function (author) {
        let atPos = author.indexOf('@')
        if (atPos > 0) {
          return author.substring(0, atPos)
        }
        return author
      }
    }
  }
</script>

<style scoped lang="scss" src="./ChangeLog.scss">

</style>
<style scoped lang="css" src="../../common-styles/smart-table.css">

</style>
